import { addDays, format } from 'date-fns';

export type TWeekDay = {
    day: number;
    name: string;
    shortName: string;
    date: Date;
};

export type TWeekDays = TWeekDay[];

export const createWeekDays = (date?: Date) => {
    const currentDate = date || new Date();

    return Array(7)
        .fill(0)
        .map((_, index) => {
            const day = addDays(currentDate, index);

            return {
                day: day.getDate(),
                name: format(day, 'iiii'),
                shortName: format(day, 'eee'),
                date: day,
            };
        });
};
